import { Configuration } from '@boatsetter/typescript-axios';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export default new Configuration({
  basePath: publicRuntimeConfig.BS_API_HOST,
});
